<template>
  <div id="Preferences">
    <div class="settings_view">
      <div class="default_top">
        <div>
          <span>Preferences</span>
        </div>
        <div></div>
      </div>

      <div class="content_preferences">
        <div class="section">
          <div>
            <span class="title">Date Format</span>
          </div>
          <div>
            <select name id>
              <option value>DD / MM / YYYY</option>
              <option value>MM / DD / YYYY</option>
              <option value>YYYY / MM / DD</option>
              <option value>YYYY / DD / MM</option>
            </select>
          </div>
        </div>

        <div class="section">
          <div>
            <span class="title">Timezone</span>
          </div>
          <div>
            <div class="setting_flex">
              <span>GMT+08:00</span>
              <b-form-checkbox name="check-button" switch>Off</b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Preferences",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
